var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("用户id:"+_vm._s(_vm.id)+"的详情 "),_c('el-input',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }